export default __webpack_public_path__ + "static/media/480_store01-it-mobile.e0492734.png";